import { Controller } from "@hotwired/stimulus"

// Submits the set-default form to the correct URL when the dropdown selection changes.
// Each <option> carries a data-url attribute pointing to the correct member route.
// Uses a hidden form with _method=PATCH so Rails processes it correctly.
export default class extends Controller {
  static targets = ["select", "form"]

  submit() {
    const select = this.selectTarget
    const selectedOption = select.options[select.selectedIndex]
    const url = selectedOption.dataset.url

    if (!url) return

    this.formTarget.action = url
    this.formTarget.submit()
  }
}
